import { AgreementDocumentData } from './agreement-document-data';
import { UserAdminData } from './user-admin-data';

export interface CarrierAgreementData {
  agreement: AgreementDocumentData;
  user: UserAdminData;
  createDtTm: Date;
  carrierAgreementDocumentId: number;
}
